const createControlTreatment = (treatmentName) => ({
    [treatmentName]: {
        treatment: "control",
    },
});
const createControlTreatments = (treatmentNames) => {
    let treatmentsObject = {};
    treatmentNames.forEach((value) => {
        const treatment = createControlTreatment(value);
        treatmentsObject = { ...treatment, ...treatmentsObject };
    });
    return treatmentsObject;
};
export default (treatmentNames) => typeof treatmentNames === "string"
    ? createControlTreatment(treatmentNames)
    : createControlTreatments(treatmentNames);
